import { useState } from 'react';
import { Calendar, Phone, Mail, MapPin, Clock } from 'lucide-react';
import CalendarPopup from './CalendarPopup';

export default function Contact() {
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);

  return (
    <>
    <section id="contact" className="py-24 bg-gradient-to-br from-aurore-dark/85 via-aurore-medium/85 to-aurore-light/90 dark:from-warm-gray-800 dark:via-warm-gray-800 dark:to-warm-gray-700 relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLW9wYWNpdHk9Ii4xIi8+PC9nPjwvc3ZnPg==')] opacity-20"></div>

      <div className="container mx-auto px-6 relative">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-8 leading-tight">
              Vous avez une question ? Posez-la maintenant
            </h2>
            <p className="text-xl text-white/95 dark:text-warm-gray-300 max-w-2xl mx-auto leading-relaxed-plus">
              Premier échange gratuit de 30 minutes. Vous m'expliquez votre situation, je vous dis si je peux vous aider et comment. Aucune obligation ensuite.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-10 mb-12">
            <div className="bg-white dark:bg-warm-gray-900 rounded-3xl p-10 shadow-md hover:shadow-lg transition-shadow duration-500">
              <div className="flex items-center space-x-4 mb-7">
                <div className="w-14 h-14 bg-aurore-light/40 dark:bg-warm-gray-700 rounded-2xl flex items-center justify-center">
                  <Calendar className="w-7 h-7 text-aurore-dark dark:text-aurore-light" />
                </div>
                <h3 className="text-2xl font-bold text-warm-gray-900 dark:text-warm-gray-100">Prendre rendez-vous en ligne</h3>
              </div>

              <p className="text-warm-gray-700 dark:text-warm-gray-300 mb-8 leading-relaxed-plus">
                Choisissez le jour et l'heure. Je vous appelle à l'heure dite. On échange 30 minutes, gratuitement et sans engagement.
              </p>

              <button
                onClick={() => setIsCalendlyOpen(true)}
                className="w-full bg-aurore-dark text-white px-8 py-5 rounded-2xl hover:bg-aurore-medium hover:shadow-lg transition-all duration-500 font-medium flex items-center justify-center space-x-3"
              >
                <Calendar className="w-5 h-5" />
                <span>Réserver mon créneau gratuit</span>
              </button>

              <p className="text-sm text-warm-gray-500 dark:text-warm-gray-400 mt-5 text-center leading-relaxed">
                Confirmation immédiate par email
              </p>
            </div>

            <div className="bg-white dark:bg-warm-gray-900 rounded-3xl p-10 shadow-md hover:shadow-lg transition-shadow duration-500">
              <div className="flex items-center space-x-4 mb-7">
                <div className="w-14 h-14 bg-aurore-light/40 dark:bg-warm-gray-700 rounded-2xl flex items-center justify-center">
                  <Phone className="w-7 h-7 text-aurore-dark dark:text-aurore-light" />
                </div>
                <h3 className="text-2xl font-bold text-warm-gray-900 dark:text-warm-gray-100">Ou m'appeler directement</h3>
              </div>

              <div className="space-y-5 mb-6">
                <a href="tel:+33750717728" className="flex items-center space-x-4 text-warm-gray-700 dark:text-warm-gray-300 hover:text-aurore-dark dark:hover:text-aurore-light transition-colors duration-300">
                  <Phone className="w-5 h-5 text-aurore-dark dark:text-aurore-light" />
                  <span className="text-lg font-semibold">07 50 71 77 28</span>
                </a>

                <a href="mailto:contact@aurorerh.fr" className="flex items-center space-x-4 text-warm-gray-700 dark:text-warm-gray-300 hover:text-aurore-dark dark:hover:text-aurore-light transition-colors duration-300">
                  <Mail className="w-5 h-5 text-aurore-dark dark:text-aurore-light" />
                  <span className="text-lg">contact@aurorerh.fr</span>
                </a>

                <div className="flex items-start space-x-4 text-warm-gray-700 dark:text-warm-gray-300">
                  <MapPin className="w-5 h-5 text-aurore-dark dark:text-aurore-light flex-shrink-0 mt-1" />
                  <span className="leading-relaxed">Toute la France (visio ou présentiel)</span>
                </div>

                <div className="flex items-start space-x-4 text-warm-gray-700 dark:text-warm-gray-300">
                  <Clock className="w-5 h-5 text-aurore-dark dark:text-aurore-light flex-shrink-0 mt-1" />
                  <span className="leading-relaxed">Réponse sous 24h maximum</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <CalendarPopup
      isOpen={isCalendlyOpen}
      onClose={() => setIsCalendlyOpen(false)}
    />
    </>
  );
}
